import _ from 'lodash';

export function MergeAttributes(objects) {
	var newObjects = _.map(objects, (object)=>{
		return _.merge(object, object.attributes);
	});
	return newObjects
}


// WEBPACK FOOTER //
// ./src/components/FlatData.js